<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <ontick-modal
      title="Detalhes da ordem"
      :open="active"
      v-on:close="$emit('closeModal')"
    >
      <div
        class="dark:border-ontick-carbon-500 border-t border-gray-500 px-0 py-5"
      >
        <dl class="grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-4 md:gap-y-8">
          <div class="sm:col-span-1">
            <dt class="titlemodal">Status:</dt>
            <dd class="label">
              <p class="mr-3 rounded">
                {{ textStatus(order.order_state) || "-" }}
              </p>
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Tipo de ordem:</dt>
            <dd class="label">
              {{ order.order_type || "-" }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="titlemodal">Finalidade:</dt>
            <dd class="label">
              {{ order.order_goal || "-" }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Ativo:</dt>
            <dd class="label">
              {{ order.order_symbol || "-" }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Horário em vigor</dt>

            <dd class="label">
              {{ order.order_time_in_force || "-" }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="titlemodal">Horário de envio</dt>

            <dd else class="label">
              {{ order.order_time_setup | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Última atualização</dt>

            <dd v-if="order.order_time_done != null" class="label">
              {{ order.order_time_done | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="titlemodal">Preço:</dt>
            <dd class="label">
              {{ order.order_price | currency || "-" }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Stop loss:</dt>
            <dd class="label">
              {{ order.order_sl | currency || "-" }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="titlemodal">Take profit:</dt>
            <dd class="label">
              {{ order.order_tp | currency || "-" }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="titlemodal">Volume</dt>
            <dd class="label">
              {{ order.order_volume }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="titlemodal">Validade:</dt>
            <dd v-show="order.order_expiration == null" class="label">-</dd>
            <dd v-show="order.order_expiration > 0" class="label">
              {{ order.order_expiration }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="titlemodal">Comentário:</dt>

            <dd class="label">
              {{ order.order_comment || "-" }}
            </dd>
          </div>
        </dl>
      </div>
    </ontick-modal>
  </transition>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "modal",

  props: {
    params_id: { type: Object, default: {} },
    active: { type: Boolean, default: false },
  },

  mounted() {
    this.orderDetails(this.params_id);
  },
  methods: {
    ...mapActions({
      orderDetails: "performance/orderDetails",
    }),

    textStatus(value) {
      let text = "";

      if (value == "CANCELED") {
        text = "Cancelada";
      } else if (value == "FILLED") {
        text = "Executada";
      } else if (value == "REJECTED") {
        text = "Rejeitada";
      } else if (value == "PARTIAL") {
        text = "Parcial";
      } else if (value == "EXPIRED") {
        text = "Expirada";
      } else if (value == "FROZEN") {
        text = "Congelada";
      } else if (value == "STARTED") {
        text = "Iniciada";
      } else if (value == "PLACED") {
        text = "Colocada ";
      }

      return text;
    },

    colorStatus(value) {
      let color = "";

      if (value == "FROZEN") {
        color =
          "background-color:rgba(142, 68, 173,0.3); color:rgba(142, 68, 173,1.0)";
      } else if (value == "PARTIAL") {
        color =
          "background-color:rgba(214, 158, 46, 0.3);color:rgba(214, 158, 46, 1)";
      } else if (value == "REJECTED") {
        color =
          "background-color:rgba(197, 48, 48, 0.3);color:rgba(197, 48, 48, 1)";
      } else if (value == "FILLED") {
        color =
          "background-color:rgba(25, 214, 132, 0.3);color:rgba(25, 214, 132, 1);";
      } else if (value == "CANCELED") {
        color =
          "background-color: rgba(7, 164, 255, 0.3);color:rgba(7, 164, 255, 1);";
      } else if (value == "PLACED") {
        color =
          "background-color: rgba(255, 255, 255, 0.3);color:rgba(255, 255, 255, 1);";
      } else if (value == "STARTED") {
        color =
          "background-color: rgba(230, 126, 34, 0.3);color:rgba(230, 126, 34,1.0);";
      } else if (value == "EXPIRED") {
        color =
          "background-color: rgba(232, 67, 147, 0.3);color:rgba(232, 67, 147,1.0);";
      }

      return color;
    },
  },
  computed: {
    ...mapState({
      order: (state) => state.performance.orders,
    }),
  },
};
</script>

<style scoped>
.titlemodal {
  @apply text-ontick-carbon-900 text-xs font-medium dark:text-gray-400 md:text-sm;
}
.label {
  @apply text-ontick-steel-700 mt-1 text-xs dark:text-white md:text-sm;
}
</style>
